<template>
  <el-dialog
    title="新增分期"
    :visible.sync="visible"
    width="890px"
    @close="close"
    :close-on-click-modal="false">
    <div style="padding: 16px;">
      <el-form ref="formRef" :model="formData" :inline="true">
        <dialogPanel>
          <ChapterHead>
            <span>病历信息</span>
            <span slot="extra">
              <el-button :loading="loading" type="primary" size="small" icon="el-icon-check" @click="saveHelpStages">提交</el-button>
              <!-- <el-button :loading="loading" type="primary" size="small" icon="el-icon-back" @click="close">取消</el-button> -->
            </span>
          </ChapterHead>
            <el-row>
              <el-form-item label="救助医院" prop="hospitalId">
                <HospitalSelect v-model="formData.hospitalId" :disabled="true" @change="hospitalChange"></HospitalSelect>
              </el-form-item>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="病种" prop="diseasesIdList">
                  <DiseaseCascader v-model="formData.diseasesIdList" :multiple="true" :disabled="true"></DiseaseCascader>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="住院号" prop="inHospitalNo" :rules="[{ required: currentHospital.isAuto == 1, message: '请输入住院号', trigger: 'change' }]">
                  <el-input v-model="formData.inHospitalNo" type="text" size="small"></el-input>
                </el-form-item>
              </el-col>
	            <el-col :span="6" v-if="currentHospital.isShowInHospitalTime == 1">
		            <el-form-item label="入院时间" prop="inHospitalTime" :rules="[{ required: currentHospital.isAuto == 1, message: '请选择入院时间', trigger: 'change' }]">
			            <el-date-picker v-model="formData.inHospitalTime" type="date" size="small"
			                            value-format="timestamp" format="yyyy-MM-dd" placeholder="选择时间" :picker-options="pickerOptions">
			            </el-date-picker>
		            </el-form-item>
	            </el-col>
              <!-- <el-col v-if="formData.initialProject == 'AY1001'" :span="12">
                <el-form-item label="病种类型" prop="diseasesType">
                  <DictionarySelect v-model="formData.diseasesType" :lazy="true" tableCode="DISEASES_TYPE" :disabled="true">
                  </DictionarySelect>
                </el-form-item>
              </el-col> -->
            </el-row>
            <el-row  v-if="currentHospital.isAuto == 1 && currentHospital.isShowInHospitalNumber==1">
              <el-col :span="12">
                <el-form-item label="住院流水号" prop="inHospitalSerialNoNew" :rules="[{required: currentHospital.isAuto == 1 && currentHospital.isShowInHospitalNumber==1, message: '请输入住院流水号', trigger: 'blur' }]">
                  <el-input v-model="formData.inHospitalSerialNoNew" size="small" />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="单次/分期" prop="quotaType">
                  <el-radio-group v-model="formData.quotaType" :disabled="true">
                    <el-radio :label="0">单次</el-radio>
                    <el-radio :label="1">分期</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="期数">
                  <el-input v-if="isAngleDiseases" type="text" :disabled="true" value="-" size="small" />
                  <el-input v-else type="text" :disabled="true" v-model="formData.totalStages" size="small" />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="当前期次">
                  <el-input type="text" :disabled="true" v-model="formData.curStages" size="small" />
                </el-form-item>
              </el-col>
            </el-row>
          </dialogPanel>
        </el-form>
        <el-collapse v-if="formData.curStages > 1" :value="['1']" >
          <el-form ref="formAttachRef" :model="formAttachData" :rules="rules" :inline="true">
            <MyCollapse title="病历附件"  iconPath="/static/de-zmr.png"  name="1">
              <el-form-item label="术前B超/诊断证明原件" prop="attachList">
                <FileUpload v-model="formAttachData.attachList"></FileUpload>
              </el-form-item>
            </MyCollapse>
          </el-form>
        </el-collapse>
    </div>
  </el-dialog>
</template>

<script>
import { getHelpRequestDataById, getCaseAttachInfoSet, addNewStagesFq ,uniqueInHospitalSerialNo} from "@/util/api";
import ChapterHead from "@/components/business/ChapterHead";
import HospitalSelect from "@/components/business/HospitalSelect";
import DictionarySelect from "@/components/business/DictionarySelect";
import DiseaseCascader from "@/components/business/DiseaseCascader";
import FileUpload from "@/components/business/FileUpload";
import dialogPanel from "@/components/business/dialogPanel";
import MyCollapse from "@/components/business/MyCollapse";

export default {
  components: {
    ChapterHead,
    HospitalSelect,
    DiseaseCascader,
    FileUpload,
    dialogPanel,
    MyCollapse,
    DictionarySelect
  },
  props: {
    visible: false,
    helpId: String,
    helpReqId: String
  },
  data () {
    let isHospitalRole = this.isHospital();
    return {
	    pickerOptions: {
		    disabledDate(time) {
			    return time.getTime() > Date.now();
		    }
	    },
      isHospitalRole: isHospitalRole,
      loading: false,
      currentHospital: {},
      isAllowStages:0,
      formAttachData: {
        attachList: [],
      },
      formData: {
        quotaType: null
      },
      rules: {
        // hospitalId: [{
        //   required: true,
        //   message: '请选择医院',
        //   trigger: 'change'
        // }],
        // diseasesIdList: [{
        //   required: true,
        //   message: '请选择病种',
        //   trigger: 'change'
        // }],
        // quotaType: [{
        //   required: true,
        //   message: '请选择是否分期',
        //   trigger: 'change'
        // }],
        // reqMode: [{
        //   required: true,
        //   message: '请选择是否代申请',
        //   trigger: 'change'
        // }],
        // diseasesType: [{
        //   required: true,
        //   message: '请选择病种类型',
        //   trigger: 'change'
        // }],
        attachList: [{
          required: true,
          message: "请上传术前B超/诊断证明原件",
          trigger: "change"
        }],
      },
      msgCodeValue: null,
      isAngleDiseases: false
    }
  },
  mounted () {
    this.loadData();
  },
  methods: {
    loadData () {
      getHelpRequestDataById({helpReqId: this.helpReqId}).then(reqData => {
        if (reqData.msgCode == 200) {
          let diseasesIdList = reqData.responseData.diseasesList && reqData.responseData.diseasesList.map(d => {
            return d.diseasesId;
          });
          const data = {
            ...reqData.responseData,
            curStages: reqData.responseData.curStages + 1,
            diseasesIdList: diseasesIdList
          };
          delete data.inHospitalNo;
          delete data.inHospitalTime;
          this.formData = data;
        } else {
          this.$message.error(reqData.msg);
        }
      });
      // getCaseAttachInfoSet({
      //   helpId: this.helpId,
      //   attachTypes: '21'
      // }).then(res => {
      //   if (res.msgCode == 200) {
      //     if (res.responseData['21'] && res.responseData['21'].length > 0) {
      //       this.formAttachData.attachList = res.responseData['21'].map(d => { return d.attachId; });
      //     }
      //   }
      // });
    },
    saveHelpStages () {
      this.$refs.formRef.validate((formValid) => {
        if (formValid) {
          this.$refs.formAttachRef.validate(async (valid) => {
            if (valid) {
              // 住院流水号校验逻辑
              if (this.currentHospital.isAuto == 1 && this.currentHospital.isShowInHospitalNumber == 1) {
                try {
                  await this.uniqueInHospitalSerialNo();
                } catch(error) {
                  return; // 校验失败时终止流程
                }
              }
              this.loading = true;
              let params = {
                helpReqId: this.helpReqId,
                hospitalId: this.formData.hospitalId,
                inHospitalNo: this.formData.inHospitalNo,
                inHospitalTime: this.formData.inHospitalTime,
                inHospitalSerialNo: this.formData.inHospitalSerialNoNew,
                newStagesCaseInfo: {
                  preoperaBUltraList: this.formAttachData.attachList.map(attachId => {
                    return {
                      attachType: '21',
                      attachId: attachId
                    }
                  })
                }
              }
              addNewStagesFq(params).then((res) => {
                this.loading = false;
                if (res.msgCode == 200) {
                  this.$emit('success', params);
                  this.$emit('close')
                } else {
                  this.$message.error(res.msg);
                }
              });
            }
          });
        }
      });
    },
    hospitalChange (id, hospital) {
      console.log(hospital)
      this.currentHospital = hospital;
    },
    close () {
      this.$emit('close')
    },
    /**
     * 校验住院流水号
     */
    uniqueInHospitalSerialNo() {
      return new Promise((resolve, reject) => {
        if (!this.formData.inHospitalSerialNo) {
          this.$message.error('住院流水号不能为空！');
          return reject();
        }

        uniqueInHospitalSerialNo({
          hospitalId: this.currentHospital.hospitalId,
          childName: this.formData.childName,
          inHospitalTime: this.formData.inHospitalTime,
          inHospitalSerialNo: this.formData.inHospitalSerialNo,
        }).then(result => {
          if (result.msgCode != 200 || !result.responseData) {
            this.$message.error('住院流水号校验失败！');
            reject();
          } else {
            resolve();
          }
        });
      });
    }
  }
}
</script>

<style lang="scss" scoped>
@import "src/common/form";
</style>



// WEBPACK FOOTER //
// src/pages/child/manage/HelpStagesAdd.vue